import React from 'react';
import './terms.css'; // Custom CSS file
import { useNavigate } from 'react-router-dom';
import GameHeader from '../header/header';
import supportImage from '../../Assets/images/support.png';
const Support = () => {
    const navigate = useNavigate();

    const handlewhatsapp = () => {
        // window.location.href = 'https://api.whatsapp.com/send/?phone=+13322692184&text=hi';
        // window.open('https://api.whatsapp.com/send/?phone=+13322692184&text=hi', '_blank');

    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className="support-bg">
                <div className="support-wrapper">
                    <div className="support-header">
                        <h2>Epic Support</h2>
                        <p className="support-hours">Platform Support Service Hours : 12:00–00:00</p>
                    </div>
                    <div className="support-image-container">
                        <img src={supportImage} alt="Support" className="support-image" />
                    </div>
                    <div className="support-content">
                        <h3>Contact us now</h3>
                        <p>If you have any questions, please contact our Live Support or go to WhatsApp for a consultation!</p>
                        <div className="support-buttons">
                            <button className="support-btn livechat">Direct To Livechat</button>
                            <button className="support-btn whatsapp">Direct To WhatsApp</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;
